<!-- MP看板 账号 表格 -->
<template>
	<div class="table-box" >
		<!-- 表头 -->
		<div class="table-th" ref="table_th" :style="{'width': table_scroll_width + 'px'}">
			<div class="table-th-cell-sticky" style="display: flex;align-items: center;">
				<div class="table-th-cell"
				:style="{'width':30 + 'px'}">
					<a-checkbox :indeterminate="indeterminate" :checked="checkAll" @change="onCheckAllChange"></a-checkbox>
				</div>
				<template v-for="(item,index) in rableTitle" name="item.type">
					<div v-if="index <= sticky_index" class="table-th-cell" style="cursor: default;"
					:style="{'width':rableTitle[index].width + 'px'}" >
						{{rableTitle[index].title}}
					</div>
				</template>
				<!-- <div class="table-th-cell"
				:style="{'width':rableTitle[0].width + 'px'}" style="cursor: default;" 
				@click="sortClick(0)">
					{{rableTitle[0].title}}
				</div> -->
				
			</div>
			
			<div  v-for="(item,index) in rableTitle" :key="index" >
	
				<div v-if="index > sticky_index && item.show_control" class="table-th-cell" 
				:style="{'width':item.width + 'px','cursor':item.sort_control?'pointer':'default','justify-content': item.text_right?'flex-end':''}"
				@click="sortClick(index)">
					{{item.title}}
					<div v-if="item.sort_control" style="display: flex;flex-direction: column;width: 12px;margin-left: 5px;">
						<a-icon type="caret-up" :style="{'color': item.sort_status === 2?'#1890ff':'#999'}" style="font-size: 12px;margin-bottom: -4px;" />
						<a-icon type="caret-down" :style="{'color': item.sort_status === 1?'#1890ff':'#999'}" style="font-size: 12px;" />
					</div>
				</div>
			</div>
			<!-- 占位，隔出一个空白区域 -->
			<div id="" style="padding:15px;"></div>
		</div>
		
		<!-- 总计 -->
		<div v-if="tableShowData.length > 0" class="table-td"  :style="{'width': table_scroll_width + 'px'}">
			<div class="table-td-cell-sticky" style="display: flex;align-items: center;">
				<!-- 选择 -->
				<div class="table-td-cell" :style="{'width':30 + 'px'}">
					
				</div>
				<div class="table-td-cell"
				:style="{'width':rableTitle[0].width + 'px'}">
					总计
				</div>
				<template v-for="(z_tem,z_ndex) in rableTitle">
					<div v-if="z_ndex > 0 && z_ndex <= sticky_index" class="table-td-cell"
					:style="{'width':rableTitle[z_ndex].width + 'px'}">
						
					</div>
				</template>
				
				<!-- <div class="table-td-cell"
				:style="{'width':rableTitle[1].width + 'px'}" >
				</div> -->
			</div>
			
			<template v-for="(z_tem,z_ndex) in rableTitle">
				<div v-if="z_ndex > sticky_index && z_tem.show_control && a_table_control.indexOf(z_tem.type) > -1" class="table-td-cell"
				 :class="{'text-right': rableTitle[z_ndex].text_right}"
				:style="{'width':rableTitle[z_ndex].width + 'px'}">
					{{ tableSumData[z_tem.type] || 0 }}
				</div>
				
				<div v-else-if="z_ndex > sticky_index && z_tem.show_control && b_table_control.indexOf(z_tem.type) > -1" class="table-td-cell"
				 :class="{'text-right': rableTitle[z_ndex].text_right}"
				:style="{'width':rableTitle[z_ndex].width + 'px'}">
					{{tableSumData[z_tem.type] | tableToFixed}}
				</div>
				
				<div v-else-if="z_ndex > sticky_index && z_tem.show_control && c_table_control.indexOf(z_tem.type) > -1" class="table-td-cell"
				 :class="{'text-right': rableTitle[z_ndex].text_right}"
				:style="{'width':rableTitle[z_ndex].width + 'px'}">
					{{tableSumData[z_tem.type]*100 | tableToFixed}}%
				</div>
				
				<div v-else-if="z_ndex > sticky_index && z_tem.show_control && p_table_control.indexOf(z_tem.type) > -1" class="table-td-cell"
				 :class="{'text-right': rableTitle[z_ndex].text_right}"
				:style="{'width':rableTitle[z_ndex].width + 'px'}">
					<!-- 公众号关注数 -->
					<template v-if="page_type == 'mp' && z_tem.type == 'follow_count'">
						<!-- mp部分的 -->
						{{tableSumData[z_tem.type] || 0}}
					</template>
					<template v-else-if="z_tem.type == 'from_follow_uv'">
						<!-- adq部分的 -->
						{{tableSumData[z_tem.type] || 0}}
					</template>
					
					<!-- 公众号关注成本 -->
					<div v-if="page_type == 'mp' && z_tem.type == 'follow_cost'">
						<!-- mp部分的 -->
						{{tableSumData[z_tem.type] | tableToFixed}}
					</div>
					<div v-else-if="z_tem.type == 'from_follow_cost'">
						<!-- adq部分的 -->
						{{tableSumData[z_tem.type] | tableToFixed}}
					</div>
				</div>
			</template>

		</div>
		
		<!-- 表格内容 -->
		<div v-for="(item,index) in tableShowData" :key="index" class="table-td"  :style="{'width': table_scroll_width + 'px'}">
			<div class="table-td-cell-sticky" style="display: flex;align-items: center;">
				<!-- 选择 -->
				<div class="table-td-cell" :style="{'width':30 + 'px'}">
					<a-checkbox :checked="item.checked" @change="onChangeCheckbox($event,index)"></a-checkbox>
				</div>
				<div  @click='operation(1,item)' class="table-td-cell"
				:style="{'width':rableTitle[0].width + 'px'}" style="color: #2F88FF;">
					{{item.account_name}}
				</div>
				<div @click='operation(2,item)' class="table-td-cell"
				:style="{'width':rableTitle[1].width + 'px'}">
					<div v-if="Object.keys(item.admin_user).length > 0" style="display: flex;align-items: center;cursor: pointer;flex-wrap: wrap;">
						<div v-for="(value,key) in item.admin_user" :key="key" style="color: #2F88FF;margin: 0 7px 3px 0;">
							{{value}}
						</div>
					</div>
					<div v-else style="color: #62a8ea;cursor: pointer;">
						未设置
					</div>
					
				</div>
				<!-- 推广内容 -->
				<div @click='operation(3,item)' class="table-td-cell"
				:style="{'width':rableTitle[2].width + 'px'}" style="color: #62a8ea;cursor: pointer;">
					<div v-if="item.content_channel || item.book_name">
						<div>{{item.content_channel}}</div>
						<div>{{item.book_name}}</div>
					</div>
					<div v-else >
						未设置
					</div>
				</div>
				<!-- 开启同步数据 -->
				<div  class="table-td-cell"
				:style="{'width':rableTitle[3].width + 'px'}">
					<a-switch size="small" :checked="item.sync_checked" default-checked @change="onSyncCheckbox($event,item)"  checked-children="开启" un-checked-children="关闭"/>
				</div>
				
				<div  class="table-td-cell"
				:style="{'width':rableTitle[4].width + 'px'}">
					<a-popover :visible="item.popover_clicked" @visibleChange="handleClickChange($event,item)" trigger="click" placement="bottom">
						<template slot="content">
						  <div>
							  <div @click="zhOperation(3,item)" class='cz-button-calss'>查看计划</div>
							  <div @click="zhOperation(2,item)" class='cz-button-calss'>查看广告</div>
							  <div @click="zhOperation(1,item)" class='cz-button-calss'>同步账户信息</div>
							  <div @click="zhOperation(5,item)" class='cz-button-calss'>同步历史数据</div>
						  </div>
						</template>
						
						<!-- <a-icon style="font-size: 18px;font-weight: bold;cursor: pointer;" type="more" /> -->
						<div style="cursor: pointer;">查看/同步</div>
					</a-popover>
					
				</div>
			</div>
			<template v-for="(z_tem,z_ndex) in rableTitle">
				<div v-if="z_ndex > sticky_index && z_tem.show_control && a_table_control.indexOf(z_tem.type) > -1" class="table-td-cell"
				 :class="{'text-right': rableTitle[z_ndex].text_right}"
				:style="{'width':rableTitle[z_ndex].width + 'px'}">
					{{ item[z_tem.type] || 0 }}
				</div>
				
				<div v-else-if="z_ndex > sticky_index && z_tem.show_control && b_table_control.indexOf(z_tem.type) > -1" class="table-td-cell"
				 :class="{'text-right': rableTitle[z_ndex].text_right}"
				:style="{'width':rableTitle[z_ndex].width + 'px'}">
					{{item[z_tem.type] | tableToFixed}}
				</div>
				
				<div v-else-if="z_ndex > sticky_index && z_tem.show_control && c_table_control.indexOf(z_tem.type) > -1" class="table-td-cell"
				 :class="{'text-right': rableTitle[z_ndex].text_right}"
				:style="{'width':rableTitle[z_ndex].width + 'px'}">
					{{item[z_tem.type]*100 | tableToFixed}}%
				</div>
				
				<div v-else-if="z_ndex > sticky_index && z_tem.show_control && p_table_control.indexOf(z_tem.type) > -1" class="table-td-cell"
				 :class="{'text-right': rableTitle[z_ndex].text_right}"
				:style="{'width':rableTitle[z_ndex].width + 'px'}">
					<!-- 公众号关注数 -->
					<template v-if="page_type == 'mp' && z_tem.type == 'follow_count'">
						<!-- mp部分的 -->
						{{item[z_tem.type] || 0}}
					</template>
					<template v-else-if="z_tem.type == 'from_follow_uv'">
						<!-- adq部分的 -->
						{{item[z_tem.type] || 0}}
					</template>
					
					<!-- 公众号关注成本 -->
					<div v-if="page_type == 'mp' && z_tem.type == 'follow_cost'">
						<!-- mp部分的 -->
						{{item[z_tem.type] | tableToFixed}}
					</div>
					<div v-else-if="z_tem.type == 'from_follow_cost'">
						<!-- adq部分的 -->
						{{item[z_tem.type] | tableToFixed}}
					</div>
				</div>
				
				<!-- 账户ID -->
				<div v-else-if="z_ndex > sticky_index && z_tem.show_control && z_tem.type == 'account_id'" class="table-td-cell" 
				:style="{'width': rableTitle[z_ndex].width + 'px'}">
					{{item[z_tem.type]}}
				</div>
			</template>
			
			
			
		</div>
		
		
		<div v-show="tableShowData.length === 0" style="text-align: center;margin: 80px 0 50px;" :style="{'width': table_null_width + 'px'}">
			<a-icon style="font-size: 70px;color: #999;" type="file-search" />
			
			<div style="color: #999;font-size: 16px;margin-top: 20px;">内容为空</div>
		</div>
		
		
		<div style="position: fixed;right: 0;bottom:0;z-index: 6;background-color: #fff;height: 90vh;width: 30px;"></div>
		<div style="position: fixed;left: 0;bottom:0;z-index: 6;background-color: #fff;height: 90vh;width: 30px;"></div>
		
		
	</div>
</template>

<script>
export default {
	name: 'MPzhTable',
	props: ['rableTitle','tableShowData','tableSumData','table_scroll_width','jj_checked','indeterminate','checkAll','table_null_width','page_type'],
	data(){
		return {
			
			select_sort_index: "", // 筛选的
			
			popover_clicked: false,
			
			a_table_control: ['cost','show','click','conversions_count','eff_total_pay_money','eff_total_left_money','eff_total_left_money_fisrt','eff_total_order_cnt','eff_total_pay_user_cnt','eff_report_pay_user_cnt'],
			b_table_control: ['avg_show_cost','avg_click_cost','ctr','conversions_cost','conversions_rate','eff_total_pay_user_cost','arpu','eff_report_pay_user_cost'],
			c_table_control: ['eff_roi','eff_roi_first'],
			p_table_control: ['follow_count','from_follow_uv','follow_cost','from_follow_cost'],
			sticky_index: 4,
		}
	},
	methods: {
		sortClick(index){ // 点击表头给内容进行排序
			let that = this
			let th_status // 0是默认，1是箭头向下，2是箭头向上
			console.log(that.rableTitle[index].type)
			if(that.rableTitle[index].sort_control){ // 是否有排序功能
				if(index !== this.select_sort_index){
					this.select_sort_index = index
					that.rableTitle.forEach(res=>{
						res.sort_status = 0
					})
					that.rableTitle[index].sort_status = 1
					th_status = 1
				}
				else { // 点击的是同一个表头
					if(that.rableTitle[index].sort_status === 0){
						that.rableTitle[index].sort_status = 1 // 箭头向下
						th_status = 1
					}
					else if(that.rableTitle[index].sort_status === 1){
						that.rableTitle[index].sort_status = 2 // 箭头向上
						th_status = 2
					}
					else if(that.rableTitle[index].sort_status === 2){
						that.rableTitle[index].sort_status = 0
						th_status = 0
					}
				}
				
				
				
				this.$emit('table-th-click', index, th_status, that.rableTitle[index].type)
			}
		},
		// editTable(index){
		// 	this.$emit('edit-td-click', index)
		// },
		
		// 操作
		operation(e,item){
			console.log(e,item)
			if(e == 1){ // 点击账户名称
				// 这里使用params方式传参，而不用query是因为，params的参数不会拼在url后面，这样子刷新页面后，传过来的参数就可以自动清空
				// this.$router.replace({name: 'JLggz_',params: {jump_id: item.adv_id}})
			}
			else if(e == 2){ // 点击负责人
				this.$emit('click-Fzr', item)
			}
			else if(e == 3){ // 推广内容
				this.$emit('click-tgnr', item)
			}
		},
		handleClickChange(e,item){
			console.log(e)
			item.popover_clicked = e
		},
		// 2.0操作的气泡框
		handleClickChange2(e,item){
			console.log(e)
			item.popover_clicked2 = e
		},
		// 表格内的操作项
		zhOperation(e,item){
			console.log(item);
			if(e == 1){ // 同步账户信息
				item.popover_clicked = false
				this.$emit('sync-zhxx-click', item, 1)
			}
			else if(e == 2){ // 查看广告
				if(this.page_type == 'mp'){
					this.$router.push({name:'MPgg_',params:{jump_id:item.account_id}})
				}
				else { // ADQ
					this.$router.push({name:'ADQgg_',params:{jump_id:item.account_id}})
				}
			}
			else if(e == 3){ // 查看计划
				if(this.page_type == 'mp'){
					this.$router.push({name:'MPjh_',params:{jump_id: item.account_id}})
				}
				else { // ADQ
					this.$router.push({name:'ADQjh_',params:{jump_id: item.account_id}})
				}
			}
			else if(e == 5){ // 同步历史数据
				item.popover_clicked = false
				this.$emit('sync-zhxx-click', item, 5)
			}
			
		},
		
		// 全选
		onCheckAllChange(e){
			this.$emit('click-All-Checkbox', e)
		},
		// 单选
		onChangeCheckbox(checkedList,index){
			this.$emit('click-Checkbox', checkedList,index)
		},
		
		// 同步2.0数据 开启/关闭
		onSyncCheckbox(e,item){
			this.$emit('sync-Checkbox', e, item)
		}
	},
	filters: {
		bookTypeFilters(value){
			// console.log("过滤器",value)
			let vvv 
			if(value === 0){
				vvv = "未设置"
			}
			else if(value === 1){
				vvv = "男频"
			}
			else if(value === 2){
				vvv = "女频"
			}
			return vvv
		},
		tableToFixed(value){ // 保留小数点后两位，四舍五入
			// console.log("过滤器",value)
			if(value){
				let v = Number(value)
				return v.toFixed(2)
			}
			else {
				return 0
			}
			
		}
	}
}
</script>

<style scoped>
.cz-button-calss {
	font-size: 13px;
	padding:10px;
	cursor: pointer;
}
.cz-button-calss:hover {
	background-color: #f4f7fa;
}

/* 表格样式-非公共/基础样式 */
.table-th-cell {
	height: 59px;
}
.table-th-cell:hover {
	background-color: #eee;
}
.table-th-cell:hover .table-th-cell-sticky{
	background-color: #eee;
}

.table-td-cell {
	font-size: 12px;
}
</style>